import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { ConfigurationsSaveRequest, ConfigurationsShowResource } from "../../../../shared/types/configurations";

const baseKey = ["configurations"];

export const configurationsService = {
	showKey: baseKey,
	show: () => axios.get<LaravelResponse<ConfigurationsShowResource>>(keyToUrl(baseKey)),
	upsertKey: baseKey,
	upsert: (request: ConfigurationsSaveRequest) => axios.put<LaravelResponse<void>>(keyToUrl(baseKey), request),
};
